import * as Sentry from '@sentry/react'
import store from '../../store/configureStore'

const sendSentryEvent = msg => {
  const {
    currentUser: { user },
    insToken: { result },
  } = store.getState()
  if (user && user.isSystemAdministrator) {
    return
  } else {
    const scope = new Sentry.Scope()
    if (user) {
      scope.setUser({
        name: user.profile.name,
        email: user.email,
        id: user._id,
        userType: user.info.userType,
      })
    }
    scope.setTransactionName(msg)
    scope.setTag('user', user)
    scope.setTag('university', result.name)
    scope.setExtras({
      universityName: result.name,
      userType: user.info.userType,
    })

    Sentry.captureException(msg, () => scope)
  }
}

export default sendSentryEvent



// WEBPACK FOOTER //
// ./src/utils/analyticsHelpers/sendSentryEvent.js